<template>
  <div class="criterio-select-lojas">
    <v-row>
      <v-col class="py-0" align="center">
        <segmentos-dialog
          :selecionados.sync="segments"
          single-select
          :disable-save="disableSave"
          :tooltip-primary-button="tooltipPrimaryButton"
          :tooltip-primary-button-message="tooltipPrimaryButtonMessage"
        />
      </v-col>
    </v-row>
    <v-chip-group column active-class="primary--text">
      <v-chip
        v-for="(segment, index) in segments"
        :key="`${index}-loaded`"
        class="disabled-chip"
        small
        close
        :ripple="false"
        :disabled="disabled"
        label="Segmentos"
        @click:close="removeSelectedSegment(index)"
      >
        <span>{{ truncate(segment.name) }}</span>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { truncate, isEmpty, cloneDeep } from 'lodash'
import { DateTime } from 'luxon'

export default {
  components: {
    SegmentosDialog: () => import('@/modules/campanhas/views/components/SegmentosDialog.vue'),
  },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Object, Number],
      default: () => ({}),
    },
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    segments: [],
  }),

  computed: {
    tooltipPrimaryButton() {
      return this.disableSave
    },
    tooltipPrimaryButtonMessage() {
      return this.disableSave ? 'Não é possível alterar um segmento estático' : ''
    },
  },

  watch: {
    segments(segments) {
      if (!segments.length) {
        this.$emit('input', {
          currentValue: {},
          currentChildren: this.values[0],
          currentIndex: this.currentIndex,
        })
      }
      if (segments.length === 1 && segments[0]._id !== this.initialValue._id) {
        this.$emit('input', {
          currentValue: { segment_data: segments[0].data, _id: segments[0]._id, name: segments[0].name, updated_at: DateTime.now().toISO() },
          currentChildren: this.values[0],
          currentIndex: this.currentIndex,
        })
        this.validate()
      }
    },
  },

  mounted() {
    if (!isEmpty(this.initialValue)) {
      this.setInitialState(this.initialValue)
    }
  },

  methods: {
    truncate(value) {
      return truncate(value, { length: 40, separator: ' ' })
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return Boolean(this.segments && this.segments.length)
    },

    async setInitialState(segment) {
      this.segments = [segment]
    },

    removeSelectedSegment(index) {
      const segments = cloneDeep(this.segments)
      segments.splice(index, 1)
      this.segments = segments
    },
  },
}
</script>

<style lang="scss">
.criterio-select-lojas {
  .select-container {
    padding: 0 15px;
  }
}
</style>
